<template>
    <div id="app" :class="pageClass">
        <router-view />
    </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    pageClass () {
      // name が未定義の保険
      return this.$route && this.$route.name
        ? `page-${this.$route.name}`
        : ''
    }
  },
  mounted () {
    // 全てのJSONの取得
    this.$store.dispatch('getJsons')
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap');

#app {
    font-family: helvetica-neue-lt-pro-cond, helvetica-neue-lt-pro, "Noto Sans JP", "游ゴシック体", "Yu Gothic", YuGothic, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "MS Pゴシック", "MS PGothic", sans-serif;
    font-size: 16px;
    color: #222222;
    word-break: break-all;
    overflow-wrap: break-word;
}

a {
    color: #222222;
    text-decoration: none;
}

img {
    vertical-align: bottom;
}

input,
button,
textarea,
select {
    padding: 0;
    margin: 0;
    font-family: "Noto Sans JP", "游ゴシック体", "Yu Gothic", YuGothic, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "MS Pゴシック", "MS PGothic", sans-serif;
    vertical-align: bottom;
    background: none;
    border: none;
    border-radius: 0;
    outline: none;
    appearance: none;

    &::placeholder {
        color: #cccccc;
    }
}

.wrap {
    max-width: 1536px;
    padding-bottom: 320px;
    margin: 0 auto;

    @media screen and (max-width: 722px) {
        padding-bottom: 240px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        padding-bottom: 280px;
    }

    &--last {
        padding-bottom: 240px;

        @media screen and (max-width: 722px) {
            padding-bottom: 160px;
        }

        @media screen and (min-width: 723px) and (max-width: 963px) {
            padding-bottom: 200px;
        }
    }

    &--min {
        @media screen and (max-width: 722px) {
            padding-right: 20px;
            padding-left: 20px;
        }

        @media screen and (min-width: 723px) and (max-width: 963px) {
            padding-right: 30px;
            padding-left: 30px;
        }

        @media screen and (min-width: 964px) and (max-width: 1523px) {
            padding-right: 50px;
            padding-left: 50px;
        }

        @media screen and (min-width: 1524px) and (max-width: 2286px) {
            padding-right: 50px;
            padding-left: 50px;
        }

        @media screen and (min-width: 2287px) {}
    }
}

#app:not(.page-home) .wrap:first-of-type {
    padding-top:80px;

    @media screen and (max-width: 722px) {
        padding-top:40px;
    }
    @media screen and (min-width: 723px) and (max-width: 963px) {
        padding-top:60px;
    }
}

</style>
